module.exports = __webpack_public_path__ + "img/clear.22bdb5e2.svg";